import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  teamModal: false,
  memberModal: false,
};

const teamsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    controlTeamModal(state) {
      state.teamModal = !state.teamModal;
    },
    controlMemberModal(state) {
      state.memberModal = !state.memberModal;
    },
  },
});

export const { controlTeamModal, controlMemberModal } = teamsSlice.actions;
export default teamsSlice.reducer;
